import { Document } from 'mobx-document'
import { MenuPageItem } from '~/models'

export default class MenuPageItemDocument extends Document<MenuPageItem> {
  protected async performFetch() {
    return null
  }
}